<template lang="pug">
.order-data-history(v-if="entries.length")
  .order-data-history__entry(
    v-for="(entry, index) in entries"
    :key="entryKey(entry, index)"
  )
    span.order-data-history__value {{ formatEntry(entry.from) }}
    span.order-data-history__separator(v-if="entry.createdBy") ·
    shNameUser.order-data-history__author(v-if="entry.createdBy" :dni="entry.createdBy")
</template>

<script>
import mFilters from '@/mixins/filters'
import shNameUser from '@/components/elements/NameUser'

export default {
  name: 'OrderDataHistory',

  mixins: [mFilters],

  components: { shNameUser },

  props: {
    entries: {
      type: Array,
      default: () => []
    },
    format: {
      type: String,
      default: 'text'
    }
  },

  methods: {
    entryKey (entry, index) {
      return `${this.format}-${entry.createdAt || index}-${entry.change || ''}`
    },

    formatEntry (value) {
      if (!value) return '—'
      if (this.format === 'phone') return this.phoneNumber(value) || value
      return value
    }
  }
}
</script>

<style lang="stylus" scoped>
.order-data-history
  display block
  width 100%
  margin-top .35rem
  padding .35rem 0 .35rem .5rem
  border-left 2px solid rgb(215, 215, 215)
  text-transform uppercase
  font-size .82rem
  line-height 1.5

.order-data-history__entry
  display flex
  flex-wrap wrap
  align-items baseline
  gap .15rem .35rem
  margin 0
  opacity .78
  word-break break-word

.order-data-history__entry + .order-data-history__entry
  margin-top .35rem

.order-data-history__author
  flex-shrink 0
  font-size inherit

.order-data-history__separator
  flex-shrink 0
  opacity .65

.order-data-history__value
  min-width 0
</style>



// WEBPACK FOOTER //
// src/components/elements/order/OrderDataHistory.vue